export default __webpack_public_path__ + "static/media/conditional_text.f0c41afb.gif";